import { themePalette } from 'styles/colors/themePalette';
import type { Theme } from '@mui/material/styles';
import { tbColors, tbPalette } from 'styles/colors';

const getMuiAutocomplete = () => ({
  styleOverrides: {
    root: {
      border: '1px solid '.concat(tbColors.all.ash[900]),
      borderRadius: '4px',
      padding: '0px 0px',
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',

      // Search icon padding (the SVG at the beginning)
      '& .MuiInputBase-root > svg:first-of-type': {
        paddingLeft: '10px',
        paddingRight: '10px',
      },

      '& .MuiInputBase-root': {
        border: 'none',
        '&:before': {
          display: 'none',
        },
        '&:after': {
          display: 'none',
        },
        '&:hover': {
          border: 'none',
          '&:not(.Mui-disabled):before': {
            borderBottom: 'none',
          },
        },
        '&.Mui-focused': {
          border: 'none',
          '&:after': {
            display: 'none',
          },
        },
      },
    },
    // Add specific chip styling at the component level
    tag: {
      backgroundColor: tbColors.all.ash[900],
      fontSize: '12px',
      color: tbPalette.text.inverse,
      fontWeight: 400,
      paddingLeft: '10px',
      paddingRight: '0px',

      '& .MuiChip-deleteIcon': {
        '&:hover': {
          color: tbPalette.text.inverse,
        },
        color: tbPalette.text.inverse,
        minWidth: '10px',
        padding: '0px',
        margin: '0px',
      },
    },
    paper: ({ theme }: { theme: Theme }) => ({
      boxShadow: theme.shadows[2],
      marginTop: '0.5px',
      fontSize: '14px',
      '& .MuiAutocomplete-noOptions': {
        padding: '8px 16px',
        color: tbPalette.text.placeholder,
      },
      '& p.MuiTypography-root.MuiTypography-body1': {
        fontSize: '14px',
      },
    }),
    listbox: {
      padding: 0,
    },
    option: {
      borderBottom: '1px solid '.concat(themePalette.semantic.interactive.surface.border.default),
      '&:last-child': {
        borderBottom: 'none',
      },
      '&[aria-selected="true"]': {
        backgroundColor: themePalette.semantic.interactive.surface.active,
      },
      '&.Mui-focused': {
        backgroundColor: themePalette.semantic.interactive.surface.hover,
      },
    },
    endAdornment: {
      padding: '0 8px',
      paddingBottom: '0px',
    },
    popupIndicator: {},
  },
});

export default getMuiAutocomplete;
